import { createRoot } from 'react-dom/client';
import App from 'es/app/App';
import './i18n';

import './index.css';

import '@ag-grid-community/styles/ag-grid.min.css';
import '@ag-grid-community/styles/ag-theme-balham.min.css';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
